import Constants from "../utils/consts";
import Utils from "../utils/utils";

var http = require("follow-redirects").https;
var qs = require("querystring");

export default async function sendReminder(uname, token, titolo, data, orario, id) {
	return new Promise(function(resolve, reject) {
		var options = {
			method: "POST",
			hostname: Constants.ipAddress,
			path: Constants.apisFolder + "sendReminder.php",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
			},
			maxRedirects: 20,
		};

		var req = http.request(options, function(res) {
			var chunks = [];

			res.on("data", function(chunk) {
				chunks.push(chunk);
			});

			res.on("end", function() {
				resolve();
			});

			res.on("error", function(error) {
				console.error(error);
				reject(error);
			});
		});

		var postData = qs.stringify({
			token: token,
			uname: uname,
			titolo: titolo,
			data: data,
			orario: orario,
			id_evento: id,
		});

		req.write(postData);

		req.end();
	});
}
